import { getDefaultLocaleForDomain, getLocalesForDomain, getReleasedDomains } from './locales';

export type DomainListEntry = {
  domain: string;
  defaultLocale: string;
  locales: string[];
};

export const getDomainsForEnv = (envName: string): DomainListEntry[] => {
  switch (envName) {
    case 'local':
      return getReleasedDomains('local').flatMap(domain => ({
        domain: domain.concat('.test'),
        defaultLocale: getDefaultLocaleForDomain(domain),
        locales: getLocalesForDomain(domain),
      }));
    case 'black':
      return [
        {
          domain: 'catalog.black.igus.com',
          defaultLocale: 'de-DE',
          locales: [],
        },
      ];
    case 'aws':
    case 'white':
      return getReleasedDomains('white').flatMap(domain => ({
        domain: domain.replace('www', 'webtest'),
        defaultLocale: getDefaultLocaleForDomain(domain),
        locales: getLocalesForDomain(domain),
      }));

    case 'orange':
    default:
      return getReleasedDomains('orange').flatMap(domain => ({
        domain,
        defaultLocale: getDefaultLocaleForDomain(domain),
        locales: getLocalesForDomain(domain),
      }));
  }
};

export const getDomainForLocale = (locale: string, environment = 'orange') => {
  if (environment === 'black') {
    return getDomainsForEnv(environment)[0].domain;
  }

  return getDomainsForEnv(environment).find(
    domainEntry =>
      domainEntry.defaultLocale === locale ||
      domainEntry.locales.some(domainEntryLocale => domainEntryLocale === locale)
  )?.domain;
};
